/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mock_Memory_Item3Inputs */

const en_mk_mock_memory_item3 = /** @type {(inputs: Mk_Mock_Memory_Item3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write prices as “Rp25k”, not “Rp 25,000”`)
};

const id_mk_mock_memory_item3 = /** @type {(inputs: Mk_Mock_Memory_Item3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga ditulis “Rp25rb”, bukan “Rp 25.000”`)
};

/**
* | output |
* | --- |
* | "Write prices as “Rp25k”, not “Rp 25,000”" |
*
* @param {Mk_Mock_Memory_Item3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mock_memory_item3 = /** @type {((inputs?: Mk_Mock_Memory_Item3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mock_Memory_Item3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mock_memory_item3(inputs)
	return en_mk_mock_memory_item3(inputs)
});